import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import moment from 'moment';
import { css, cx } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import ImageWrapper from './ImageWrapper';
import { typography } from '../styles';

const styles = css`
  .BlogCard_inner {
    display: block;
    color: black;
    background-color: #000;
    &:hover {
      text-decoration: none;
    }
    @media (min-width: 768px) {
    }
    @media (min-width: 992px) {
      transition: transform 300ms ease, box-shadow 300ms ease;
      box-shadow: 0 0px 0px 0 rgba(0,0,0,0.0);
      &:hover {
        transform: scale(.99,.99);
        box-shadow: 0 6px 8px 0 rgba(0,0,0,0.2);
      }
    }
    @media (min-width: 1200px) {
    }
  }
  .BlogCard_date {
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 4.5px;
    line-height: 1.375143;
    text-transform: uppercase;
    color: white;
    @media (min-width: 768px) {
      font-size: 13px;
    }
    @media (min-width: 992px) {
      font-size: 14px;
    }
  }
  .BlogCard_title {
    font-size: 17px;
    font-weight: bold;
    letter-spacing: 0.022727em;
    line-height: 1.409091;
    font-family: ${typography.Serif};
    text-transform: capitalize;
    @media (min-width: 768px) {
      font-size: 19px;
    }
    @media (min-width: 992px) {
      font-size: 26px;
      letter-spacing: 0.54px;
    }
  }
  .BlogCard_imageWrapper {
    width: 100%;
    height: 186px;
    margin-bottom: 20px;
    @media (min-width: 376px) {
      height: 220px;
    }
    @media (min-width: 768px) {
      margin-bottom: 24px;
    }
    @media (min-width: 992px) {
      height: 286px;
      margin-bottom: 30px;
    }
  }
  .BlogCard_preview {
    font-size: 14px;
    letter-spacing: 0.010625;
    line-height: 1.75;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 1.4em;
    @media (min-width: 768px) {
      font-size: 15px;
    }
    @media (min-width: 992px) {
      width: 84%;
      font-size: 16px;
      line-height: 1.9375;
      margin-bottom: 1.1875em;
    }
  }
  .BlogCard_arrow {

  }
`;


function BlogCard({ className, post }) {
  const postTitle = get(post, 'title');

  return (
    <div className={cx(styles, className)}>
      <Link
        className="BlogCard_inner"
        name="blogpost-detail"
        params={{ blogpostTitle: postTitle }}
        aria-label={`Read full post: ${postTitle}`}
      >
        <ImageWrapper
          className="BlogCard_imageWrapper"
          src={get(post, 'logo.contentUrl')}
          alt={get(post, 'logo.name', '')}
          width={500}
          height={500}
        />
        <div className="BlogCard_date">
          {moment(get(post, 'date')).format('MMMM DD, YYYY')}
        </div>
        <h3 className="BlogCard_title GoldText">{postTitle}</h3>
        <img src="/images/i-arrow-right-gold.svg" alt="Read Blog" className="BlogCard_arrow" aria-hidden="true" />
      </Link>
    </div>
  );
}

BlogCard.propTypes = {
  className: PropTypes.string,
  post: PropTypes.object.isRequired,
};

BlogCard.defaultProps = {
  className: '',
};

export default BlogCard;



// WEBPACK FOOTER //
// ./src/components/BlogCard.js